import { Select } from "antd";
import { formatarCodigoContabil, TypePlanoContas } from "../../../../Models/Financeiro/PlanoContas";
import { useListarPlanoDeContas } from "../../../../Services/Financeiro/PlanoContasService";
import { SelectComPesquisa } from "../../../SelectComPesquisa";

interface IPlanoDeContasSelect extends Omit<React.ComponentProps<typeof Select>, "onChange" | "value" | "showSearch" | "optionFilterProp" | "filterOption"> 
{
    filtros?: TypePlanoContas;
    onChange?: ((planoConta: TypePlanoContas | null) => void) | ((codigosPlanosDeContas: number[] | null, planosDeContas: TypePlanoContas[] | null) => void);
    value?: TypePlanoContas | null;
}



export default function PlanoDeContasSelect({
    filtros,
    loading,
    placeholder,
    allowClear,
    onChange,
    value,
    mode,
    ...rest
}:IPlanoDeContasSelect) {
    placeholder = placeholder ?? "Selecione";
    allowClear = allowClear ?? true;
    loading = loading ?? false;
    
    const {
        data,
        isLoading
    } = useListarPlanoDeContas({
        planoDeContas : filtros
    });

    return <SelectComPesquisa
        {...rest}
        mode={mode}
        placeholder={placeholder}
        allowClear={allowClear}
        loading={isLoading || loading}
        onChange={(codigo: TypePlanoContas["codigo"]) => {
            if (mode === "multiple") 
                onChange?.(codigo ?? null, (codigo as Array<any>|undefined)?.map(m => data?.find(f => f.codigo == m)) ?? null);
            else
                onChange?.(data?.find(f => f.codigo == (codigo ?? null)) ?? null);
        }}
        value={typeof value === "object" ? value?.codigo : value}
        options={data?.map(m => {
            let codigoContabil = formatarCodigoContabil(m);
            
            return {
                value : m.codigo,
                label : `${codigoContabil} ${m.descricao}`.trim(),
                label2 : `${codigoContabil.replaceAll(".", "")} ${m.descricao}`.trim()
            }
        })}
        filterOption={(input, option) => (option?.label ?? '').replaceAll('.', '').toLocaleLowerCase().includes((input ?? '').replaceAll('.', '').toLocaleLowerCase())}
    />
}

export function PlanoDeContasSelectItem({
    filtros,
    loading,
    placeholder,
    allowClear,
    onChange,
    value,
    mode,
    ...rest
}:Omit<IPlanoDeContasSelect, "onChange"|"value"> & {
    value?:number|undefined;
    onChange?:(value:number|undefined, record:TypePlanoContas|undefined) => void;
}) {
    return <PlanoDeContasSelect
        {...rest}
        mode={undefined}
        onChange={(value: TypePlanoContas|null) => {
            onChange?.(value?.codigo ?? undefined, value ?? undefined);
        }}
        value={{ codigo : value ?? undefined }}
        filtros={filtros}
    />
}